module.exports = __webpack_public_path__ + "img/hey-marvelous.fef40087.png";